import React from 'react';

const IconMinus = ({ color, width, height }) => {
  return (
    <svg fill={color} height={height} width={width} viewBox="0 0 24 24">
      <path d="M19 13H5v-2h14v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

export default IconMinus;



// WEBPACK FOOTER //
// ./src/IconMinus.js